export const translations = {
  bg: {
    // Header
    email: "info@urbancage.bg",
    phone: "+359 888 360 339",
    menu: "Меню",
    
    // Hero Section
    brandName: "UrbanCage®",
    whatIsUrbanCage: "Какво е UrbanCage®",
    heroSlogan: "Премиум мултиспорт съоръжения от ново поколение. Създадени да издържат. Проектирани да впечатляват.",
    ctaRequestInquiry: "Направи запитване",
    
    // Intro Section
    introDesc: "UrbanCage® е българска патентована мултиспорт арена за модерна градска среда.\nМонтира се за един ден като преместваем обект с разрешение за поставяне – без тежка строителна техника. Облагородява междублокови пространства и училищни дворове, може да се сглоби в различни размери и форми и осигурява безопасна, защитена зона, която мотивира младите да спортуват. Издръжлива, вандалоустойчива и без нужда от поддръжка – решение за всеки град, с мисъл за младото поколение.",
    
    // Who Is Urban Cage For
    whoForTitle: "За кого е UrbanCage®",
    institution: "Общини, Училища и Градска среда",
    institutionDesc1: "<strong>Безкомпромисна вандалоустойчивост</strong> – Метална конструкция с двустранно заварена мрежа и прахово покритие, устояваща на интензивна градска употреба и вандалски прояви.",
    institutionDesc2: "<strong>Максимална безопасност</strong> – Сертифицирана затворена система без остри ръбове, гарантираща сигурност за децата и спокойствие за родителите.",
    institutionDesc3: "<strong>Устойчива инвестиция</strong> – Решение с нулева поддръжка, което пести обществени средства и напълно елиминира нуждата от ежегодни ремонти.",
    
    architect: "Архитекти и Строителни компании",
    architectDesc1: "<strong>Спортна зона на минимална площ</strong> – Пълноценно решение за плътно застроени зони, без да жертвате ценни квадратни метри от вашия проект.",
    architectDesc2: "<strong>Висока добавена стойност</strong> – Превръща затворените комплекси и бизнес сгради в много по-атрактивно и предпочитано място за живот и работа.",
    architectDesc3: "<strong>Защита за фасади и паркинги</strong> – Затворената система задържа играта вътре, предпазвайки околните стъклени витрини, автомобили и пешеходци.",
    
    hotel: "Хотели и ризорти",
    hotelDesc1: "<strong>Премиум визия за обекта</strong> – Модерен индустриален дизайн, който естествено повишава категорията и престижа на всеки хотелски комплекс.",
    hotelDesc2: "<strong>Магнит за нови гости</strong> – Силно конкурентно предимство, което ефективно привлича семейства с деца, корпоративни клиенти и тиймбилдинги.",
    hotelDesc3: "<strong>Експресен и чист монтаж</strong> – Готово съоръжение само за 1 ден, без тежки строителни процеси, излишен шум и замърсяване на територията ви.",
    
    // Patented Product
    patentedTitle: "UrbanCage® в цифри",
    patentedTitleEU: "UrbanCage® в цифри",
    patentedDesc: "1 ден за монтаж без тежка строителна техника\n15 000+ заварки в едно игрище за максимална здравина\n3 м височина на конструкцията, с възможност за надграждане до 5 м с мрежи\n8 часа автономно соларно LED осветление\n55–60 м² минимална площ за пълна функционалност\n100+ комбинации от размери, форми и конфигурации\n5 години гаранция на конструкцията\n20+ години експлоатационен живот\n0 разходи за поддръжка и електричество",
    patentedTagline: "",
    
    // Pricing
    pricingTitle: "Цени",
    priceIncludes: "*Всички цени са без ДДС",
    priceFrom: "От",
    priceCustom: "По поръчка",
    mostPopular: "Най-популярен",
    makeInquiry: "НАПРАВИ ЗАПИТВАНЕ",
    
    // Model Size Gallery / Configurator
    modelSizeTitle: "UrbanCage® конфигуратор",
    configuratorSubtitle: "Избери модел, размер и добави опции",
    priceFromLabel: "Цена от:",
    dimensionsLabel: "Размери:",
    
    // Flooring Options
    flooringTitle: "Спортна настилка",
    flooringSubtitle: "Избери тип настилка (единичен избор)",
    flooringAcrylic: "Акрилна спортна настилка",
    flooringGrass: "Изкуствена трева",
    flooringPolypropylene: "Полипропиленови модулни плочи",
    flooringEPDM: "Саморазливна гума с EPDM",
    flooringSBR: "SBR каучук",
    perSqm: "€/m²",
    
    // Upgrade Add-ons
    upgradesTitle: "UPGRADE добавки",
    upgradesSubtitle: "Избери количество (множествен избор)",
    addonFitness: "Фитнес модул",
    addonSolarLED: "Автономни соларни LED прожектори (2 бр.)",
    addonBench: "Модул пейка 1.50 м",
    addonTrash: "Кошчета за боклук (2 бр.)",
    
    // Total & Export
    totalPriceLabel: "ОБЩА ЦЕНА:",
    totalPriceFrom: "ОТ",
    exportConfig: "ИЗТЕГЛИ ТВОЯТА КОНФИГУРАЦИЯ",
    modelRect: "Правоъгълно игрище",
    sizeCustom: "По поръчка",
    sendInquiryBtn: "ИЗПРАТИ ЗАПИТВАНЕ ЗА ТВОЯТА КОНФИГУРАЦИЯ",
    configurationTitle: "Твоята UrbanCage® Конфигурация",
    
    // No Flooring Option
    noFlooring: "Без настилка",
    noFlooringDesc: "Само подготвена основа",
    
    // Duplex Coating
    duplexCoating: "Боядисване с Duplex система (двуслойно боядисване)",
    duplexCoatingInfo: "Двуслойно прахово боядисване – комбинация от епоксиден прахов грунд и втори слой от полиестерна прахова боя. Постига се корозоустойчивост клас C4 по ISO 12944 за зони с висока влажност край море и реки. Резултатът е 3 пъти по-устойчиво покритие и 5 години гаранция срещу ръжда.",
    
    // Configuration Summary
    configSummaryModel: "Модел",
    configSummarySize: "Размер",
    configSummaryColor: "Цвят",
    configSummaryFlooring: "Настилка",
    configSummaryDuplex: "Duplex система",
    configSummaryUpgrades: "Добавки",
    configSummaryYes: "Да",
    configSummaryNo: "Не",
    
    // Urban Cage Select
    selectTitle: "UrbanCage® Select",
    selectSubtitle: "Цветови решения за всеки проект",
    visualIdentity: "Визуална идентичност — цветови комбинации",
    slateBlaze: "Asphalt Grey",
    slateBlazeDesc: "тъмно сиво и оранжево",
    forestFire: "Moss Green",
    forestFireDesc: "зелено и оранжево",
    obsidianAmber: "Jet Black",
    obsidianAmberDesc: "черно и оранжево",
    oceanGold: "Concrete Grey",
    oceanGoldDesc: "светло сиво и оранжево",
    
    surfaceSystems: "Спортни настилки",
    acrylicSurface: "Акрилна спортна повърхност",
    acrylicDesc: "Висока издръжливост и професионални характеристики",
    sbrRubber: "SBR каучук",
    sbrDesc: "Еластична и устойчива на удари повърхност",
    artificialTurf: "Изкуствена трева",
    artificialDesc: "Идеална за мултиспортни игри",
    modularTiles: "Полипропиленови модулни плочки",
    modularDesc: "Бърз монтаж и лесна подмяна",
    epdmRubber: "EPDM самонивелираща гума",
    epdmDesc: "Безшевна и безопасна повърхност",
    
    qualityStatement: "Прахово боядисана, клас С3 съгласно ISO 12944 за максимална дълготрайност",
    customColorNote: "За по-специфични изисквания, предлагаме пълна персонализация на цветовата комбинация",
    
    // Gallery
    galleryTitle: "Галерия",
    
    // Video Section
    videoTitle: "Вижте UrbanCage® в действие",
    
    // Contact Form
    contactTitle: "Свържете се с нас",
    contactSubtitle: "Изпратете запитване и нашият екип ще се свърже с вас скоро",
    formName: "Име",
    formCompany: "Компания",
    formEmail: "Имейл",
    formPhone: "Телефон",
    formModel: "Модел UC",
    formMessage: "Съобщение",
    formSubmit: "ИЗПРАТИ ЗАПИТВАНЕ",
    formSuccess: "Благодарим! Вашето запитване е изпратено успешно.",
    formSuccessMessage: "Вашето запитване беше изпратено успешно!",
    formErrorMessage: "Възникна грешка. Моля, опитайте отново.",
    
    // Footer
    footerCopyright: "© UrbanCage®. Всички права запазени.",
    footerNav: "Навигация"
  },
  
  en: {
    // Header
    email: "info@urbancage.bg",
    phone: "+359 888 360 339",
    menu: "Menu",
    
    // Hero Section
    brandName: "UrbanCage®",
    whatIsUrbanCage: "What is UrbanCage®",
    heroSlogan: "Premium next-generation multi-sport facilities. Built to last. Designed to impress.",
    ctaRequestInquiry: "Request Inquiry",
    
    // Intro Section
    introDesc: "UrbanCage® is an EU-patented multi-sport arena for modern urban environments.\nIt is installed in a single day as a relocatable structure with a placement permit – no heavy construction equipment required. It enhances spaces between residential blocks and school courtyards, can be assembled in various sizes and shapes, and provides a safe, protected zone that motivates young people to play sports. Durable, vandal-resistant, and maintenance-free – a solution for every city, designed with the younger generation in mind.",
    
    // Who Is Urban Cage For
    whoForTitle: "Who is UrbanCage® for",
    institution: "Municipalities, Schools & Urban Spaces",
    institutionDesc1: "<strong>Uncompromising vandal-resistance</strong> – Robust construction with C3-class coating, withstanding intensive urban use and vandalism.",
    institutionDesc2: "<strong>Maximum safety</strong> – Certified enclosed system without sharp edges, ensuring security for children and peace of mind for parents.",
    institutionDesc3: "<strong>Sustainable investment</strong> – Zero-maintenance solution that saves public funds and completely eliminates the need for annual repairs.",
    
    architect: "Architects & Construction Companies",
    architectDesc1: "<strong>Sports zone on minimal footprint</strong> – Complete solution for densely built areas without sacrificing valuable square meters from your project.",
    architectDesc2: "<strong>High added value</strong> – Transforms gated communities and business buildings into much more attractive and preferred places to live and work.",
    architectDesc3: "<strong>Protection for facades and parking</strong> – The enclosed system keeps the game inside, protecting surrounding glass facades, vehicles, and pedestrians.",
    
    hotel: "Hotels & Resorts",
    hotelDesc1: "<strong>Premium look for your property</strong> – Modern industrial design that naturally elevates the category and prestige of any hotel complex.",
    hotelDesc2: "<strong>Magnet for new guests</strong> – Strong competitive advantage that effectively attracts families with children, corporate clients, and team buildings.",
    hotelDesc3: "<strong>Express and clean installation</strong> – Ready facility in just 1 day, without heavy construction processes, excess noise, or site contamination.",
    
    // Patented Product
    patentedTitle: "UrbanCage® in Numbers",
    patentedTitleEU: "UrbanCage® in Numbers",
    patentedDesc: "1 day installation without heavy construction equipment\n15,000+ welds in a single arena for maximum strength\n3 m structure height, with option to extend up to 5 m with nets\n8 hours of autonomous solar LED lighting\n55–60 m² minimum area for full functionality\n100+ combinations of sizes, shapes, and configurations\n5-year structural warranty\n20+ years operational lifespan\n0 maintenance and electricity costs",
    patentedTagline: "",
    
    // Pricing
    pricingTitle: "Pricing",
    priceIncludes: "*All prices are VAT excluded",
    priceFrom: "From",
    priceCustom: "Custom design",
    mostPopular: "Most Popular",
    makeInquiry: "MAKE AN INQUIRY",
    
    // Model Size Gallery / Configurator
    modelSizeTitle: "UrbanCage® Configurator",
    configuratorSubtitle: "Choose model, size and add options",
    priceFromLabel: "Price from:",
    dimensionsLabel: "Dimensions:",
    
    // Flooring Options
    flooringTitle: "Sport Flooring",
    flooringSubtitle: "Select flooring type (single choice)",
    flooringAcrylic: "Acrylic Sports Surface",
    flooringGrass: "Artificial Grass",
    flooringPolypropylene: "Polypropylene Modular Tiles",
    flooringEPDM: "Self-Leveling EPDM Rubber",
    flooringSBR: "SBR Rubber",
    perSqm: "€/m²",
    
    // Upgrade Add-ons
    upgradesTitle: "UPGRADE Add-ons",
    upgradesSubtitle: "Select quantity (multiple choice)",
    addonFitness: "Fitness Module",
    addonSolarLED: "Autonomous Solar LED Lights (2 units)",
    addonBench: "Bench Module 1.50 m",
    addonTrash: "Trash Bins (2 units)",
    
    // Total & Export
    totalPriceLabel: "TOTAL PRICE:",
    totalPriceFrom: "FROM",
    exportConfig: "DOWNLOAD YOUR CONFIGURATION",
    modelRect: "Rectangular cage",
    sizeCustom: "Custom size",
    sendInquiryBtn: "SEND INQUIRY FOR YOUR CONFIGURATION",
    configurationTitle: "Your UrbanCage® Configuration",
    
    // No Flooring Option
    noFlooring: "No Flooring",
    noFlooringDesc: "Prepared base only",
    
    // Duplex Coating
    duplexCoating: "Duplex Coating System (dual-layer painting)",
    duplexCoatingInfo: "Dual-layer powder coating – a combination of epoxy powder primer and a second layer of polyester powder paint. Achieves corrosion resistance class C4 according to ISO 12944 for high humidity zones near seas and rivers. The result is 3 times more durable coating and 5 years warranty against rust.",
    
    // Configuration Summary
    configSummaryModel: "Model",
    configSummarySize: "Size",
    configSummaryColor: "Color",
    configSummaryFlooring: "Flooring",
    configSummaryDuplex: "Duplex System",
    configSummaryUpgrades: "Add-ons",
    configSummaryYes: "Yes",
    configSummaryNo: "No",
    
    // Urban Cage Select
    selectTitle: "UrbanCage® Select",
    selectSubtitle: "Color solutions for every project",
    visualIdentity: "Visual Identity — Color Combinations",
    slateBlaze: "Asphalt Grey",
    slateBlazeDesc: "Dark grey and orange",
    forestFire: "Moss Green",
    forestFireDesc: "Green and orange",
    obsidianAmber: "Jet Black",
    obsidianAmberDesc: "Black and orange",
    oceanGold: "Concrete Grey",
    oceanGoldDesc: "Light grey and orange",
    
    surfaceSystems: "Sports Flooring",
    acrylicSurface: "Acrylic Sports Surface",
    acrylicDesc: "High durability and professional characteristics",
    sbrRubber: "SBR Rubber",
    sbrDesc: "Elastic and impact-resistant surface",
    artificialTurf: "Artificial Grass",
    artificialDesc: "Perfect for multi-sport games",
    modularTiles: "Polypropylene Modular Tiles",
    modularDesc: "Quick installation and easy replacement",
    epdmRubber: "Self-Leveling EPDM Rubber",
    epdmDesc: "Seamless and safe surface",
    
    qualityStatement: "Powder coated, C3-class according to ISO 12944 for maximum durability",
    customColorNote: "For more specific requirements, we offer full customization of color combinations",
    
    // Gallery
    galleryTitle: "Gallery",
    
    // Video Section
    videoTitle: "See UrbanCage® in action",
    
    // Contact Form
    contactTitle: "Contact Us",
    contactSubtitle: "Send an inquiry and our team will get back to you soon",
    formName: "Name",
    formCompany: "Company",
    formEmail: "Email",
    formPhone: "Phone",
    formModel: "Model UC",
    formMessage: "Message",
    formSubmit: "SEND INQUIRY",
    formSuccess: "Thank you! Your inquiry has been sent successfully.",
    formSuccessMessage: "Your inquiry has been sent successfully!",
    formErrorMessage: "An error occurred. Please try again.",
    
    // Footer
    footerCopyright: "© UrbanCage®. All rights reserved.",
    footerNav: "Navigation"
  },
  
  fr: {
    // Header
    email: "info@urbancage.bg",
    phone: "+359 888 360 339",
    menu: "Menu",
    
    // Hero Section
    brandName: "UrbanCage®",
    whatIsUrbanCage: "Qu'est-ce qu'UrbanCage®",
    heroSlogan: "Installations multisport premium de nouvelle génération. Conçues pour durer. Créées pour impressionner.",
    ctaRequestInquiry: "Demander un devis",
    
    // Intro Section
    introDesc: "UrbanCage® est une arène multisport brevetée au niveau européen, conçue pour les environnements urbains modernes.\nElle s'installe en une seule journée en tant qu'objet amovible avec permis de pose – sans engins de chantier lourds. Elle valorise les espaces entre immeubles et les cours d'école, peut être assemblée en différentes tailles et formes, et offre une zone sécurisée qui motive les jeunes à pratiquer le sport. Durable, résistante au vandalisme et sans entretien – une solution pour chaque ville, pensée pour la jeune génération.",
    
    // Who Is Urban Cage For
    whoForTitle: "Pour qui est UrbanCage®",
    institution: "Municipalités, Écoles et Espaces Urbains",
    institutionDesc1: "<strong>Résistance au vandalisme sans compromis</strong> – Construction robuste avec revêtement classe C3, résistant à une utilisation urbaine intensive et aux actes de vandalisme.",
    institutionDesc2: "<strong>Sécurité maximale</strong> – Système fermé certifié sans bords tranchants, garantissant la sécurité des enfants et la tranquillité d'esprit des parents.",
    institutionDesc3: "<strong>Investissement durable</strong> – Solution sans entretien qui économise les fonds publics et élimine complètement le besoin de réparations annuelles.",
    
    architect: "Architectes et Entreprises de Construction",
    architectDesc1: "<strong>Zone sportive sur empreinte minimale</strong> – Solution complète pour les zones densément construites sans sacrifier de précieux mètres carrés de votre projet.",
    architectDesc2: "<strong>Haute valeur ajoutée</strong> – Transforme les résidences fermées et les bâtiments commerciaux en lieux de vie et de travail beaucoup plus attractifs et recherchés.",
    architectDesc3: "<strong>Protection des façades et parkings</strong> – Le système fermé garde le jeu à l'intérieur, protégeant les vitrines environnantes, les véhicules et les piétons.",
    
    hotel: "Hôtels et Resorts",
    hotelDesc1: "<strong>Aspect premium pour votre propriété</strong> – Design industriel moderne qui élève naturellement la catégorie et le prestige de tout complexe hôtelier.",
    hotelDesc2: "<strong>Aimant pour nouveaux clients</strong> – Avantage concurrentiel fort qui attire efficacement les familles avec enfants, les clients d'entreprise et les team buildings.",
    hotelDesc3: "<strong>Installation express et propre</strong> – Installation prête en seulement 1 jour, sans processus de construction lourds, bruit excessif ou contamination du site.",
    
    // Patented Product
    patentedTitle: "UrbanCage® en chiffres",
    patentedTitleEU: "UrbanCage® en chiffres",
    patentedDesc: "1 jour d'installation sans engins de chantier lourds\n15 000+ soudures dans une seule arène pour une solidité maximale\n3 m de hauteur de structure, avec possibilité d'extension jusqu'à 5 m avec des filets\n8 heures d'éclairage LED solaire autonome\n55–60 m² de surface minimale pour une fonctionnalité complète\n100+ combinaisons de tailles, formes et configurations\n5 ans de garantie sur la structure\n20+ ans de durée de vie opérationnelle\n0 frais d'entretien et d'électricité",
    patentedTagline: "",
    
    // Pricing
    pricingTitle: "Tarification",
    priceIncludes: "*Tous les prix sont hors TVA",
    priceFrom: "À partir de",
    priceCustom: "Conception personnalisée",
    mostPopular: "Le plus populaire",
    makeInquiry: "FAIRE UNE DEMANDE",
    
    // Model Size Gallery / Configurator
    modelSizeTitle: "Configurateur UrbanCage®",
    configuratorSubtitle: "Choisissez le modèle, la taille et les options",
    priceFromLabel: "Prix à partir de:",
    dimensionsLabel: "Dimensions:",
    
    // Flooring Options
    flooringTitle: "Revêtement Sportif",
    flooringSubtitle: "Sélectionnez le type de revêtement (choix unique)",
    flooringAcrylic: "Surface sportive acrylique",
    flooringGrass: "Gazon artificiel",
    flooringPolypropylene: "Dalles modulaires en polypropylène",
    flooringEPDM: "Caoutchouc EPDM auto-nivelant",
    flooringSBR: "Caoutchouc SBR",
    perSqm: "€/m²",
    
    // Upgrade Add-ons
    upgradesTitle: "UPGRADE Add-ons",
    upgradesSubtitle: "Sélectionnez la quantité (choix multiple)",
    addonFitness: "Module Fitness",
    addonSolarLED: "Projecteurs LED solaires autonomes (2 unités)",
    addonBench: "Module banc 1.50 m",
    addonTrash: "Poubelles (2 unités)",
    
    // Total & Export
    totalPriceLabel: "PRIX TOTAL:",
    totalPriceFrom: "À PARTIR DE",
    exportConfig: "TÉLÉCHARGER VOTRE CONFIGURATION",
    modelRect: "Cage rectangulaire",
    sizeCustom: "Sur mesure",
    sendInquiryBtn: "ENVOYER UNE DEMANDE POUR VOTRE CONFIGURATION",
    configurationTitle: "Votre Configuration UrbanCage®",
    
    // No Flooring Option
    noFlooring: "Sans revêtement",
    noFlooringDesc: "Base préparée uniquement",
    
    // Duplex Coating
    duplexCoating: "Système de revêtement Duplex (peinture double couche)",
    duplexCoatingInfo: "Revêtement poudré double couche – une combinaison d'apprêt poudré époxy et d'une seconde couche de peinture poudre polyester. Atteint une résistance à la corrosion classe C4 selon ISO 12944 pour les zones à forte humidité près des mers et rivières. Le résultat est un revêtement 3 fois plus durable et 5 ans de garantie contre la rouille.",
    
    // Configuration Summary
    configSummaryModel: "Modèle",
    configSummarySize: "Taille",
    configSummaryColor: "Couleur",
    configSummaryFlooring: "Revêtement",
    configSummaryDuplex: "Système Duplex",
    configSummaryUpgrades: "Options",
    configSummaryYes: "Oui",
    configSummaryNo: "Non",
    
    // Urban Cage Select
    selectTitle: "UrbanCage® Select",
    selectSubtitle: "Solutions de couleurs pour chaque projet",
    visualIdentity: "Identité visuelle — Combinaisons de couleurs",
    slateBlaze: "Asphalt Grey",
    slateBlazeDesc: "Gris foncé et orange",
    forestFire: "Moss Green",
    forestFireDesc: "Vert et orange",
    obsidianAmber: "Jet Black",
    obsidianAmberDesc: "Noir et orange",
    oceanGold: "Concrete Grey",
    oceanGoldDesc: "Gris clair et orange",
    
    surfaceSystems: "Revêtements sportifs",
    acrylicSurface: "Surface sportive acrylique",
    acrylicDesc: "Haute durabilité et caractéristiques professionnelles",
    sbrRubber: "Caoutchouc SBR",
    sbrDesc: "Surface élastique et résistante aux chocs",
    artificialTurf: "Gazon artificiel",
    artificialDesc: "Parfait pour les jeux multisports",
    modularTiles: "Dalles modulaires en polypropylène",
    modularDesc: "Installation rapide et remplacement facile",
    epdmRubber: "Caoutchouc EPDM auto-nivelant",
    epdmDesc: "Surface sans couture et sécurisée",
    
    qualityStatement: "Revêtement poudré, classe C3 selon ISO 12944 pour une durabilité maximale",
    customColorNote: "Pour des exigences plus spécifiques, nous offrons une personnalisation complète des combinaisons de couleurs",
    
    // Gallery
    galleryTitle: "Galerie",
    
    // Video Section
    videoTitle: "Voir UrbanCage® en action",
    
    // Contact Form
    contactTitle: "Contactez-nous",
    contactSubtitle: "Envoyez une demande et notre équipe vous répondra bientôt",
    formName: "Nom",
    formCompany: "Entreprise",
    formEmail: "E-mail",
    formPhone: "Téléphone",
    formModel: "Modèle UC",
    formMessage: "Message",
    formSubmit: "ENVOYER LA DEMANDE",
    formSuccess: "Merci! Votre demande a été envoyée avec succès.",
    formSuccessMessage: "Votre demande a été envoyée avec succès!",
    formErrorMessage: "Une erreur s'est produite. Veuillez réessayer.",
    
    // Footer
    footerCopyright: "© UrbanCage®. Tous droits réservés.",
    footerNav: "Navigation"
  },
  
  de: {
    // Header
    email: "info@urbancage.bg",
    phone: "+359 888 360 339",
    menu: "Menü",
    
    // Hero Section
    brandName: "UrbanCage®",
    whatIsUrbanCage: "Was ist UrbanCage®",
    heroSlogan: "Premium Multisport-Anlagen der nächsten Generation. Gebaut für die Ewigkeit. Gestaltet um zu beeindrucken.",
    ctaRequestInquiry: "Anfrage senden",
    
    // Who Is Urban Cage For
    whoForTitle: "Für wen ist UrbanCage®",
    institution: "Gemeinden, Schulen und Stadtgebiete",
    institutionDesc1: "<strong>Kompromisslose Vandalismusbeständigkeit</strong> – Robuste Konstruktion mit C3-Klasse-Beschichtung, die intensiver städtischer Nutzung und Vandalismus standhält.",
    institutionDesc2: "<strong>Maximale Sicherheit</strong> – Zertifiziertes geschlossenes System ohne scharfe Kanten, das Sicherheit für Kinder und Seelenfrieden für Eltern garantiert.",
    institutionDesc3: "<strong>Nachhaltige Investition</strong> – Wartungsfreie Lösung, die öffentliche Mittel spart und den Bedarf an jährlichen Reparaturen vollständig eliminiert.",
    
    architect: "Architekten und Bauunternehmen",
    architectDesc1: "<strong>Sportzone auf minimaler Grundfläche</strong> – Komplettlösung für dicht bebaute Gebiete, ohne wertvolle Quadratmeter Ihres Projekts zu opfern.",
    architectDesc2: "<strong>Hoher Mehrwert</strong> – Verwandelt geschlossene Wohnanlagen und Geschäftsgebäude in viel attraktivere und bevorzugte Lebens- und Arbeitsorte.",
    architectDesc3: "<strong>Schutz für Fassaden und Parkplätze</strong> – Das geschlossene System hält das Spiel innen, schützt umliegende Glasfassaden, Fahrzeuge und Fußgänger.",
    
    hotel: "Hotels & Resorts",
    hotelDesc1: "<strong>Premium-Look für Ihr Objekt</strong> – Modernes Industriedesign, das die Kategorie und das Prestige jedes Hotelkomplexes natürlich erhöht.",
    hotelDesc2: "<strong>Magnet für neue Gäste</strong> – Starker Wettbewerbsvorteil, der Familien mit Kindern, Firmenkunden und Teambuildings effektiv anzieht.",
    hotelDesc3: "<strong>Express- und saubere Installation</strong> – Fertige Anlage in nur 1 Tag, ohne schwere Bauprozesse, übermäßigen Lärm oder Standortverschmutzung.",
    
    // Patented Product
    patentedTitle: "UrbanCage® in Zahlen",
    patentedTitleEU: "UrbanCage® in Zahlen",
    patentedDesc: "1 Tag Montage ohne schwere Baumaschinen\n15.000+ Schweißnähte in einer Arena für maximale Festigkeit\n3 m Konstruktionshöhe, mit Erweiterungsmöglichkeit auf 5 m mit Netzen\n8 Stunden autonome Solar-LED-Beleuchtung\n55–60 m² Mindestfläche für volle Funktionalität\n100+ Kombinationen aus Größen, Formen und Konfigurationen\n5 Jahre Strukturgarantie\n20+ Jahre Betriebslebensdauer\n0 Wartungs- und Stromkosten",
    patentedTagline: "",
    
    // Pricing
    pricingTitle: "Preisgestaltung",
    priceIncludes: "*Alle Preise verstehen sich ohne MwSt",
    priceFrom: "Ab",
    priceCustom: "Individuelles Design",
    mostPopular: "Am beliebtesten",
    makeInquiry: "ANFRAGE STELLEN",
    
    // Model Size Gallery / Configurator
    modelSizeTitle: "UrbanCage® Konfigurator",
    configuratorSubtitle: "Wählen Sie Modell, Größe und Optionen",
    priceFromLabel: "Preis ab:",
    dimensionsLabel: "Abmessungen:",
    
    // Flooring Options
    flooringTitle: "Sportboden",
    flooringSubtitle: "Bodenbelag auswählen (Einzelauswahl)",
    flooringAcrylic: "Acryl-Sportoberfläche",
    flooringGrass: "Kunstrasen",
    flooringPolypropylene: "Modulare Polypropylen-Fliesen",
    flooringEPDM: "Selbstnivellierende EPDM-Gummi",
    flooringSBR: "SBR-Gummi",
    perSqm: "€/m²",
    
    // Upgrade Add-ons
    upgradesTitle: "UPGRADE Add-ons",
    upgradesSubtitle: "Menge auswählen (Mehrfachauswahl)",
    addonFitness: "Fitnessmodul",
    addonSolarLED: "Autonome Solar-LED-Strahler (2 Stück)",
    addonBench: "Bankmodul 1.50 m",
    addonTrash: "Mülleimer (2 Stück)",
    
    // Total & Export
    totalPriceLabel: "GESAMTPREIS:",
    totalPriceFrom: "AB",
    exportConfig: "IHRE KONFIGURATION HERUNTERLADEN",
    modelRect: "Rechteckiger Cage",
    sizeCustom: "Maßanfertigung",
    sendInquiryBtn: "ANFRAGE FÜR IHRE KONFIGURATION SENDEN",
    configurationTitle: "Ihre UrbanCage® Konfiguration",
    
    // No Flooring Option
    noFlooring: "Ohne Bodenbelag",
    noFlooringDesc: "Nur vorbereitete Basis",
    
    // Duplex Coating
    duplexCoating: "Duplex-Beschichtungssystem (Zweischicht-Lackierung)",
    duplexCoatingInfo: "Zweischicht-Pulverbeschichtung – eine Kombination aus Epoxid-Pulvergrundierung und einer zweiten Schicht Polyester-Pulverlack. Erreicht Korrosionsbeständigkeitsklasse C4 nach ISO 12944 für Zonen mit hoher Luftfeuchtigkeit in der Nähe von Meeren und Flüssen. Das Ergebnis ist eine 3-mal haltbarere Beschichtung und 5 Jahre Garantie gegen Rost.",
    
    // Configuration Summary
    configSummaryModel: "Modell",
    configSummarySize: "Größe",
    configSummaryColor: "Farbe",
    configSummaryFlooring: "Bodenbelag",
    configSummaryDuplex: "Duplex-System",
    configSummaryUpgrades: "Add-ons",
    configSummaryYes: "Ja",
    configSummaryNo: "Nein",
    
    // Urban Cage Select
    selectTitle: "UrbanCage® Select",
    selectSubtitle: "Farblösungen für jedes Projekt",
    visualIdentity: "Visuelle Identität — Farbkombinationen",
    slateBlaze: "Asphalt Grey",
    slateBlazeDesc: "Dunkelgrau und Orange",
    forestFire: "Moss Green",
    forestFireDesc: "Grün und Orange",
    obsidianAmber: "Jet Black",
    obsidianAmberDesc: "Schwarz und Orange",
    oceanGold: "Concrete Grey",
    oceanGoldDesc: "Hellgrau und Orange",
    
    surfaceSystems: "Sportböden",
    acrylicSurface: "Acryl-Sportoberfläche",
    acrylicDesc: "Hohe Haltbarkeit und professionelle Eigenschaften",
    sbrRubber: "SBR-Gummi",
    sbrDesc: "Elastische und stoßfeste Oberfläche",
    artificialTurf: "Kunstrasen",
    artificialDesc: "Perfekt für Multisport-Spiele",
    modularTiles: "Modulare Polypropylen-Fliesen",
    modularDesc: "Schnelle Installation und einfacher Austausch",
    epdmRubber: "Selbstnivellierende EPDM-Gummi",
    epdmDesc: "Nahtlose und sichere Oberfläche",
    
    qualityStatement: "Pulverbeschichtet, C3-Klasse nach ISO 12944 für maximale Haltbarkeit",
    customColorNote: "Für spezifischere Anforderungen bieten wir vollständige Anpassung der Farbkombinationen",
    
    // Gallery
    galleryTitle: "Galerie",
    
    // Video Section
    videoTitle: "Sehen Sie UrbanCage® in Aktion",
    
    // Contact Form
    contactTitle: "Kontaktieren Sie uns",
    contactSubtitle: "Senden Sie eine Anfrage und unser Team wird sich bald bei Ihnen melden",
    formName: "Name",
    formCompany: "Unternehmen",
    formEmail: "E-Mail",
    formPhone: "Telefon",
    formModel: "Modell UC",
    formMessage: "Nachricht",
    formSubmit: "ANFRAGE SENDEN",
    formSuccess: "Vielen Dank! Ihre Anfrage wurde erfolgreich gesendet.",
    formSuccessMessage: "Ihre Anfrage wurde erfolgreich gesendet!",
    formErrorMessage: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    
    // Footer
    footerCopyright: "© UrbanCage®. Alle Rechte vorbehalten.",
    footerNav: "Navigation"
  }
};
